import { twJoin } from "tailwind-merge";

import { InfoCircleIcon } from "@/components/Icons/InfoCircleIcon";
import { Tooltip } from "@/components/Tooltip/Tooltip";

interface InfoProps {
  tooltip: NonNullable<React.ReactNode>;
  grayscale?: boolean;
}
export function Info({ tooltip, grayscale }: InfoProps): React.ReactNode {
  return (
    <Tooltip tooltip={tooltip} offsetY={5}>
      <InfoCircleIcon
        size={16}
        className={twJoin("shrink-0", grayscale ? "text-grey-700" : "text-aop-basic-blue-500 hover:text-blue-700")}
      />
    </Tooltip>
  );
}
